export default __webpack_public_path__ + "static/banner-welcome-to-living-digitally-d5876b6b07d780b04f29128b4eaf667b.jpg";